import * as Yup from 'yup';
import { DictEnvelopeContent } from '@models';

export function useValidationSchema() {
  return Yup.object<DictEnvelopeContent>().shape({
    name: Yup.string().nullable().required(),
  });
}
